import { useQueryClient } from 'react-query'
import { useStrategy } from '../hooks/useStrategy'

export const useInvalidateActivitiesQuery = () => {
    const queryClient = useQueryClient()
    const strategy = useStrategy()

    const invalidateActivitiesQuery = async () => {
        await Promise.all([
            queryClient.invalidateQueries(['activities', strategy?._id]),
            queryClient.invalidateQueries(['orgActivities', strategy?.organizationId]),
        ])
    }

    return { invalidateActivitiesQuery }
}
